import Vue from 'vue'
import Router from 'vue-router'
import { ROUTE_PATH } from './Const'
import store from '../store'
import { STORE_CONST } from '../store/Const'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      // 非routes設定的的path, 一律導向'/'
      path: '*',
      redirect: '/'
    },
    {
      // 登入頁
      name: 'Login',
      path: '/login',
      component: () => import('@/views/Login/Index')
    },
    {
      name: 'Index',
      path: '/',
      redirect: ROUTE_PATH.GUIDE.ROOT,
      component: () => import('@/views/Main'),
      meta: { requiresAuth: true },
      children: [
        {
          // Calculation route
          path: 'calculation/:name',
          name: 'calculation',
          component: () => import('@/views/Calculation/Index'),
          beforeEnter (to, from, next) {
            store.commit(STORE_CONST.APP_SIDEBAR.MUTATIONS.SHOW)
            if ((from.name === ROUTE_PATH.GUIDE.NAME_PURPOSE) || (from.name === ROUTE_PATH.GUIDE.NAME_AUDIENCE)) {
              store.dispatch('speedCalculation2/setIsFromGuide', true)
              store.dispatch('speedCalculation2/setShowBackButton', true)
            } else {
              store.dispatch('speedCalculation2/setShowBackButton', false)
            }
            // name 只能是 SI SV LINE 三種，預設 SI
            if (!ROUTE_PATH.PRODUCT_LINES.includes(to.params.name)) {
              next({
                path: `calculation/${ROUTE_PATH.PRODUCT_LINES[0]}`
              })
            }
            next()
          }
        },
        {
          // Compare route
          path: 'compare',
          component: () => import('@/views/Compare/Index'),
          beforeEnter (to, from, next) {
            store.commit(STORE_CONST.APP_SIDEBAR.MUTATIONS.SHOW)
            next()
          },
          children: [
            {
              name: 'Compare',
              path: '',
              component: () => import('@/views/Compare/Index')
            }
          ]
        },
        {
          // Guide route
          path: ROUTE_PATH.GUIDE.ROOT,
          component: () => import('@/views/Guide/Index'),
          beforeEnter (to, from, next) {
            store.commit(STORE_CONST.APP_SIDEBAR.MUTATIONS.HIDE)
            next()
          }
        },
        {
          path: ROUTE_PATH.GUIDE.PURPOSE + ':currentStep',
          name: ROUTE_PATH.GUIDE.NAME_PURPOSE,
          component: () => import('@/views/Guide/PurposePathWrapper'),
          beforeEnter (to, from, next) {
            store.commit(STORE_CONST.APP_SIDEBAR.MUTATIONS.HIDE)
            store.dispatch(STORE_CONST.GUIDE_ACTIONS.ROOT.GET_OPTION_DATA)
              .then((res) => { next() })
              .catch(() => { next() })
          }
        },
        {
          path: ROUTE_PATH.GUIDE.AUDIENCE + ':currentStep',
          name: ROUTE_PATH.GUIDE.NAME_AUDIENCE,
          component: () => import('@/views/Guide/PathAudienceWrapper'),
          beforeEnter (to, from, next) {
            store.commit(STORE_CONST.APP_SIDEBAR.MUTATIONS.HIDE)
            store.dispatch(STORE_CONST.GUIDE_ACTIONS.ROOT.GET_OPTION_DATA).then((res) => {
              next()
            })
          }
        }
      ]
    }
  ]
})
